<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-format-list-bulleted</v-icon>
        <v-toolbar-title>Policy Type Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- <v-card> -->
        <v-card-title>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
          <v-flex xs12 class="mt-3">
            <message :messages="messages"></message>
          </v-flex>
        </v-card-title>
        <v-btn @click="toggleAll">All</v-btn>
        <v-btn @click="toggleNone">None</v-btn>
        <v-card-text>
          <v-data-table
            v-bind:headers="headers"
            v-bind:items="items"
            v-bind:search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="key"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
            v-model="selected"
            show-select
          >
          </v-data-table>
        </v-card-text>
        <!-- </v-card> -->
        <div class="pt-2">
          <v-btn color="primary" @click="doSelect">Select Policy Type</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
export default {
  props: {
    polType: String
  },
  data() {
    return {
      headers: [
        { text: 'Policy Type', value: 'polType' },
        { text: 'Description', value: 'polTypeDesc' }
      ],
      selected: [],
      reportPolType: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.uwMotorParam.menu
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      if (this.polType) {
        this.reportPolType = this.polType.split(',')
      } else {
        this.reportPolType = []
      }
      const apiURI = this.menu.getPolTypeList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            this.polTypeItems = []
            const { data } = result.data
            if (data) {
              data.map((list) => {
                const convertList = {
                  key: list.value,
                  polType: list.value,
                  polTypeDesc: list.secondaryValue
                }
                if (this.reportPolType.includes(list.value)) {
                  const polTypeList = {
                    key: list.value,
                    polType: list.value,
                    polTypeDesc: list.secondaryValue
                  }
                  this.polTypeItems.push(polTypeList)
                }
                this.items.push(convertList)
              })
            }
            if (this.polType === 'All') {
              this.toggleAll()
            } else {
              this.toggleSelectedPolType()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    toggleAll() {
      this.selected = this.items.slice()
    },
    toggleSelectedPolType() {
      this.selected = this.polTypeItems.slice()
    },
    toggleNone() {
      this.selected = []
    },
    doSelect() {
      const selectedItems = []
      for (var i = 0; i < this.selected.length; i++) {
        selectedItems.push(this.selected[i].polType)
      }
      const polTypeObj = {
        selectedItems: selectedItems,
        totalLength: this.items.length
      }
      this.$emit('doAssign', polTypeObj)
      this.$emit('close')
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
